import * as less from './index.less';
import * as vendors from './vendors';
import React from 'react';
import ReactDOM from 'react-dom';
import throttle from 'lodash.throttle';
import classnames from 'classnames';

class Image extends React.Component {
  render() {
    const { url, height, onLoad } = this.props;
    return (<img className="image-gallery-item" src={url} height={height} onLoad={onLoad} />)
  }
}

class ImageGallery extends React.Component {
  constructor(props) {
    super(props);

    this.state = { position: 0, numberOfPositions: 0, translateX: 0 }
    this.goLeft = this.goLeft.bind(this);
    this.goRight = this.goRight.bind(this);
    this.updatePosition = this.updatePosition.bind(this);
    this.image_onLoad = this.image_onLoad.bind(this);
  }

  image_onLoad(e) {
    this.updatePosition(this.state.position);
  }

  componentDidMount() {
    this.updatePosition(0);

    $(window).on('resize', throttle(() => {
      this.updatePosition(this.state.position);
    }, 500));
  }

  componentWillUnmount() {
    $(window).off('resize');
  }

  updatePosition(nextPosition) {
    const { position, numberOfPositions, translateX } = this.computeDistance(nextPosition);
    this.setState({ position, numberOfPositions, translateX });
  }

  computeDistance(nextPosition) {
    const visibleWidth = $(window).width() / 2;
    let imageListWidth = 20;
    $(this.imageList).find("img").each((i, ele) => {
      imageListWidth += $(ele).width() + 20;
    });

    if (imageListWidth > (visibleWidth * 2)) {
      const minX = (visibleWidth * 2) - imageListWidth;
      const numberOfPositions = 1 + Math.abs(Math.ceil(minX / visibleWidth));

      if (nextPosition > numberOfPositions) {
        nextPosition = numberOfPositions;
      } if (nextPosition < 0) {
        nextPosition = 0;
      }

      let translateX = Math.max(-(visibleWidth * nextPosition), minX);

      return { position: nextPosition, numberOfPositions, translateX };
    } else {
      return { position: 0, numberOfPositions: 0, translateX: 0 };
    }
  }

  goLeft(e) {
    e.preventDefault();

    this.updatePosition(this.state.position - 1);
  }

  goRight(e) {
    e.preventDefault();

    this.updatePosition(this.state.position + 1);
  }

  render() {
    const { images, height } = this.props;
    const { numberOfPositions } = this.state;

    const imageComps = images.map(i => {
      return (<li key={i}><Image url={i} height={height} onLoad={this.image_onLoad} /></li>)
    });

    const style = {
      transition: 'transform 0.5s',
      transform: `translateX(${this.state.translateX}px)`
    };

    const nextClass = classnames({
      'image-gallery-next': true,
      'hide': numberOfPositions === 0
    });

    const prevClass = classnames({
      'image-gallery-prev': true,
      'hide': numberOfPositions === 0
    });

    return (
      <div className="image-gallery">
        <a href="#" onClick={this.goLeft} className={prevClass} role="button">
          <img src="/images/arrow-left.png" width="30" height="52" />
          <span className="sr-only">Prev</span>
        </a>
        <a href="#" onClick={this.goRight} className={nextClass} role="button">
          <img src="/images/arrow-right.png" width="30" height="52" />
          <span className="sr-only">Next</span>
        </a>

        <ul ref={ ref => this.imageList = ref } className="list-inline" style={style}>{imageComps}</ul>
      </div>
    );
  }
}

window.janos_initImageGallery = (elementId, images, height) => {
  return ReactDOM.render(
    <ImageGallery images={images} height={height} />,
    document.getElementById(elementId)
  );
}



// WEBPACK FOOTER //
// ./src/index.jsx